<template>
  <div class="footer-info-block">
    <SmartLink
      :url="contract"
      target="_blank"
      class="footer-link"
    >
      Договір оферти
    </SmartLink>
    <SmartLink
      :url="`tel:${phone}`"
      class="footer-link"
    >
      {{ phone }}
    </SmartLink>
    <SmartLink
      :url="`mailto:${email}`"
      class="footer-link"
    >
      {{ email }}
    </SmartLink>
  </div>
</template>

<script>
import { linkResolver } from '@/shared/lib/route';
import { SmartLink } from '@/shared/ui/link';

export default {
  props: {
    contract: {
      type: String,
      required: true,
    },
    phone: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
  },
  mixins: [ linkResolver ],
  components: { SmartLink },
};
</script>

<style scoped>
.footer-info-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
}

.footer-link {
  display: inline-block;
  font-family: inherit;
  font-size: 14px;
  line-height: 14px;
  color: #999da6;
  text-decoration: none;
  text-align: center;
  margin-bottom: 10px;
  border-bottom: 1px solid transparent;
  transition: border-color 0.2s;

  &:hover {
    border-bottom: 1px solid #999da6;
  }
}
</style>
